var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-final-modal',_vm._g(_vm._b({attrs:{"name":"cart-time","classes":['vfm-container vfm-content']},scopedSlots:_vm._u([{key:"default",fn:function({close}){return undefined}}])},'vue-final-modal',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }